/* Home page (sections/home-tattup.liquid): the hero montage video. Only the poster loads with the page; the mp4
   (data-lazy-src from snippets/cz-hero-collage.liquid: 360 px copy on phones, 540 px on desktop, 720 px on desktop
   screens with devicePixelRatio >= 1.5) is set once the poster has loaded and the video is on screen, then plays muted
   in a loop and pauses when scrolled away or the tab is hidden. No video at all with "reduce motion" or the data saver –
   the poster stays. Rails, arrows and the before/after drag: assets/plp-tattup.js. */
(function () {
  if (window.__hmxLoaded) return;
  window.__hmxLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function initVideo(root) {
    var v = root.querySelector('[data-hmx-hero-video] video');
    if (!v || v.dataset.hmxInit) return;
    v.dataset.hmxInit = '1';
    v.muted = true;
    if (reduce || saveData) { v.removeAttribute('autoplay'); v.pause(); return; }

    var visible = false;
    var started = false;
    var play = function () {
      if (!visible || document.hidden) return;
      if (!started) {
        var slow = navigator.connection && /2g|3g/.test(navigator.connection.effectiveType || '');
        var small = slow || window.innerWidth < 990;
        var sharp = !small && (window.devicePixelRatio || 1) >= 1.5; /* Retina / 4K desktop: 720 px copy */
        var src = (small && v.getAttribute('data-lazy-src-sd')) || (sharp && v.getAttribute('data-lazy-src-hd')) || v.getAttribute('data-lazy-src');
        if (src) { v.src = src; v.preload = 'auto'; }
        started = true;
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    var watching = false;
    var watch = function () {
      if (watching) return; watching = true;
      if (!('IntersectionObserver' in window)) { visible = true; play(); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) play(); else if (started) v.pause();
        });
      }, { threshold: 0.15 }).observe(v.closest('.czl-hm--video') || v); /* the frame: the video sits 1 px inside it (perf) */
    };
    /* start right after the poster (the LCP image) is on screen – no longer waiting for window load, which on this
       shop only fires after all third-party app scripts (often 10–20 s on phones). A short idle gap keeps the main
       thread free for the first paint. */
    var start = function () {
      var go = function () { watch(); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 600 });
      else setTimeout(go, 200);
    };
    var poster = root.querySelector('.czl-hm__poster');
    if (!poster || (poster.complete && poster.naturalWidth)) start();
    else { poster.addEventListener('load', start, { once: true }); poster.addEventListener('error', start, { once: true }); setTimeout(start, 2500); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) { if (started) v.pause(); } else play(); });
  }

  function init() {
    document.querySelectorAll('.hmx--hero').forEach(initVideo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
